import type { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'glossary',
        name: 'Glossary',
        description: 'Help employees understand your company-specific terms, abbreviations, etc.',
        descriptionLong: (
            <p>
                Define company-specific terms, values, or culture words in the company settings. Whenever a keyword
                appears in user-written text across the app, it will be highlighted and show its explanation. This way,
                your employees can look up terminology while they’re in the flow and don’t have to leave SI to look up
                terms elsewhere.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_glossary',
        imgSrc: require('./images/glossary.jpg'),
        hideIfDisabled: false,
    },
    {
        id: 'review-overview-views',
        name: 'View Presets in Reviews',
        description: 'Browse the Reviews list by Progress or by Results, and store your fine tuned options for later.',
        descriptionLong: (
            <>
                <p>
                    The Review list is highly adjustable, but you need to know what you’re looking for. And once you’ve
                    adjusted the columns and filters and charts to your needs, you need to readjust for the next
                    use-case.
                </p>
                <p>
                    Our new Views give admins smart defaults for tracking progress and for analyzing results. Any
                    adjustment is stored to the screen’s configuration for later.
                </p>
                <p>
                    Soon we’ll include a Calibration view, and mid-term you’ll be able to add your own Views, and share
                    them with peer admins.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewViews',
        imgSrc: require('./images/views.png'),
        hideIfDisabled: false,
    },
    {
        id: 'ai-coach-mcp',
        name: 'Connect to external AI (via MCP)',
        description: 'Analyze and process your organization’s SI data in your preferred LLM.',
        descriptionLong: (
            <>
                <p>
                    You can now connect Claude, ChatGPT, or any other{' '}
                    <span
                        data-tooltip="Model Context Protocol"
                        style={{ textDecoration: 'underline', textDecorationStyle: 'dotted' }}
                    >
                        MCP
                    </span>
                    -compatible AI tool to Small Improvements and work with the data of your SI account right inside a
                    chat: e.g., analyzing reviews, digging into 1:1 history, tracking objectives, and more.
                </p>
                <p>
                    In a first step, HR administrators can enable read-access to content such as Reviews, 1:1s and
                    Objectives. Soon, the MCP connection will become available to regular staff as well, and you’ll be
                    able to assign write-access and more fine-grained permissions.
                </p>
                <p>
                    Reach out to <a href="mailto:product@small-improvements.com">product@small-improvements.com</a> to
                    join the EAP program and tell us what you’d like to do with it.
                </p>
            </>
        ),
        type: 'announcement',
        imgSrc: require('./images/mcp.png'),
        imgNoBorder: true,
        hideIfDisabled: false,
    },
];
